export default __webpack_public_path__ + "assets/plant.png";